import { withInstall } from '@ll-plus/utils'

import Empty from './src/empty.vue'

export const LlEmpty = withInstall(Empty)
export default LlEmpty
export * from './src/empty'

declare module 'vue' {
  export interface GlobalComponents {
    LlEmpty: typeof Empty
  }
}
